module.exports = __webpack_public_path__ + "assets/img/6719cab8523e6f01af18214e9219f034.png";